import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Button, Checkbox, FormControlLabel } from '@mui/material';
import React, { useState } from 'react';
import ComparisonTable from 'src/pages/NewBillingModule/ApplyBillingFull/comparisonTable';
import useStyles from './styles';
const SPIKE_MESSAGE = 'Your allocation amount has increased by more than 20% since last time.';
const REVIEW_MESSAGE = 'Please review the comparison between the current and previous allocations and check the checkbox below.';

/**
 * The rows as the comparison table reads them. Every figure on a previous cycle is optional to the
 * allocation service, and the table prints them all.
 */
function toComparison(comparison) {
  return _objectSpread(_objectSpread({}, comparison), {}, {
    allocations: ((comparison === null || comparison === void 0 ? void 0 : comparison.allocations) || []).map(row => {
      var _row$activeUnits, _row$allocatedTotal, _row$commonAreaDeduct, _row$goodwillDeductio, _row$totalBilledToRes, _row$totalOccupants;
      return _objectSpread(_objectSpread({}, row), {}, {
        activeUnits: (_row$activeUnits = row.activeUnits) !== null && _row$activeUnits !== void 0 ? _row$activeUnits : 0,
        allocatedTotal: (_row$allocatedTotal = row.allocatedTotal) !== null && _row$allocatedTotal !== void 0 ? _row$allocatedTotal : 0,
        commonAreaDeduction: (_row$commonAreaDeduct = row.commonAreaDeduction) !== null && _row$commonAreaDeduct !== void 0 ? _row$commonAreaDeduct : 0,
        goodwillDeduction: (_row$goodwillDeductio = row.goodwillDeduction) !== null && _row$goodwillDeductio !== void 0 ? _row$goodwillDeductio : 0,
        totalBilledToResident: (_row$totalBilledToRes = row.totalBilledToResident) !== null && _row$totalBilledToRes !== void 0 ? _row$totalBilledToRes : 0,
        totalOccupants: (_row$totalOccupants = row.totalOccupants) !== null && _row$totalOccupants !== void 0 ? _row$totalOccupants : 0
      });
    })
  });
}

/**
 * Shown for a service the allocation service is holding back because the bill rose sharply on the
 * last one. It will not be approved until somebody has compared it with the cycles before it, so
 * the comparison is offered here rather than sending the reader to the billing cycle to find it.
 */
export function AllocationSpikeReview(_ref) {
  let comparison = _ref.comparison,
    _ref$isSaving = _ref.isSaving,
    isSaving = _ref$isSaving === void 0 ? false : _ref$isSaving,
    onReview = _ref.onReview;
  const classes = useStyles();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const isReviewed = !!(comparison !== null && comparison !== void 0 && comparison.isReviewed);
  // Nothing to review, and nothing to confirm having reviewed, until the comparison is to hand.
  const hasComparison = ((comparison === null || comparison === void 0 ? void 0 : comparison.allocations) || []).length > 0;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.reviewBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.reviewText
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.reviewTitle
  }, SPIKE_MESSAGE), /*#__PURE__*/React.createElement("span", {
    className: classes.warningText
  }, REVIEW_MESSAGE), /*#__PURE__*/React.createElement(FormControlLabel, {
    className: classes.reviewCheckbox,
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: isReviewed,
      disabled: isReviewed || isSaving || !hasComparison || !onReview,
      onChange: () => onReview && onReview(),
      size: "small"
    }),
    label: "I reviewed the comparison with the previous cycles."
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.reviewAction
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !hasComparison,
    onClick: () => setIsOpen(true),
    size: "small",
    variant: "actionButtonInvert"
  }, "Review comparison")), /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: () => setIsOpen(false),
    isOpen: isOpen
    // Nine columns of figures: at the default width they would have to be scrolled sideways.
    ,
    noLeftButton: true,
    rightButton: /*#__PURE__*/React.createElement(Button, {
      onClick: () => setIsOpen(false),
      size: "small",
      variant: "contained"
    }, "Done"),
    title: "Compare to previous cycles",
    variant: "large"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.comparison
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.warningBox
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "warning",
    type: "info"
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.warningText
  }, SPIKE_MESSAGE)), /*#__PURE__*/React.createElement(ComparisonTable, {
    comparison: toComparison(comparison)
  }))));
}